/** The Ledger's search and filter in the URL (TMMAPP-0108, TMM-B6). */
import { enumParam, stringParam } from '@/shared/useUrlState';

export const LEDGER_FILTERS = ['all', 'unassigned', 'uncategorized'] as const;

export type LedgerFilter = (typeof LEDGER_FILTERS)[number];

export const LEDGER_URL = {
  q: stringParam(),
  filter: enumParam<LedgerFilter>(LEDGER_FILTERS, 'all'),
};
